"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

var _jsxruntime = require('react/jsx-runtime');

var C = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ChevronUpIconSmall",
  size: "Small",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M3.11113 13.2634L3.73708 13.889C3.88523 14.037 4.12544 14.037 4.27362 13.889L10 8.17997L15.7264 13.8889C15.8746 14.037 16.1148 14.037 16.2629 13.8889L16.8889 13.2634C17.037 13.1154 17.037 12.8753 16.8889 12.7272L10.2682 6.11104C10.1201 5.96299 9.87989 5.96299 9.73171 6.11104L3.11113 12.7273C2.96296 12.8753 2.96296 13.1154 3.11113 13.2634Z"
  }),
  svgElements: ["path"]
}),
    a = exports.b = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ChevronUpIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M6.14289 18.0793L6.94767 18.8612C7.13815 19.0463 7.44699 19.0463 7.63751 18.8612L15 11.725L22.3625 18.8612C22.553 19.0462 22.8618 19.0462 23.0524 18.8612L23.8571 18.0793C24.0476 17.8942 24.0476 17.5941 23.8571 17.409L15.3449 9.1388C15.1544 8.95373 14.8456 8.95373 14.6551 9.1388L6.14289 17.4091C5.95237 17.5942 5.95237 17.8942 6.14289 18.0793Z"
  }),
  svgElements: ["path"]
}),
    t = exports.c = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ChevronUpIconExtraSmall",
  size: "ExtraSmall",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M2.07938 9.44758L2.52648 9.91672C2.6323 10.0278 2.80388 10.0278 2.90973 9.91672L7 5.63498L11.0903 9.9167C11.1961 10.0277 11.3677 10.0277 11.4735 9.9167L11.9206 9.44755C12.0265 9.33651 12.0265 9.15648 11.9206 9.04542L7.19161 4.08328C7.08579 3.97224 6.91421 3.97224 6.80837 4.08328L2.07938 9.04544C1.97354 9.1565 1.97354 9.33654 2.07938 9.44758Z"
  }),
  svgElements: ["path"]
});

exports.a = C;
exports.b = a;
exports.c = t;